function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { TabNavigation as TabNavigation$1 } from '@cbhq/cds-web/tabs/TabNavigation';
import { componentsThemeMap } from '../componentsThemeMap.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function TabNavigation({
  tabs,
  children,
  startTabId,
  style = 'default'
}) {
  const _useState = useState(startTabId || tabs?.[0]?.id),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const background = componentsThemeMap[style].background;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(TabNavigation$1, {
      value: activeTab,
      tabs: tabs
      // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
      ,

      onChange: value => {
        setActiveTab(value);
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
      ,

      background: background
    }), tabs?.length > 0 &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
    children.filter((child, i) => {
      return Number(activeTab) === i;
    })]
  });
}
export { TabNavigation };
//# sourceMappingURL=TabNavigation.js.map
